const initMe = null;

export default function (state = initMe, action) {
  switch (action.type) {
    case "SET_ME":
      return action.payload;
    default:
      return state;
  }
}
